import { Component, OnInit } from '@angular/core';

import { SpinnerService } from '../../../services/spinner.service';
import { RecurrentService } from '../../../services/recurrent.service';
import { CategoryService } from '../../../services/category.service';

@Component({
    selector: 'app-recurrent-list',
    templateUrl: './recurrent-list.component.html',
    styleUrls: ['./recurrent-list.component.css']
})
export class RecurrentListComponent implements OnInit {
    get days() {
        return Array.apply(null, {length: 28}).map(Number.call, Number)
    };
    amount_multiplier: number = 1;
    newRec: any = {
        day: 1,
        amount: 0,
        account: '',
        active: true,
        comment: '',
        category: null,
        recurrent: null,
        months: [
            { number: 0, active: true},
            { number: 1, active: true},
            { number: 2, active: true},
            { number: 3, active: true},
            { number: 4, active: true},
            { number: 5, active: true},
            { number: 6, active: true},
            { number: 7, active: true},
            { number: 8, active: true},
            { number: 9, active: true},
            { number: 10, active: true},
            { number: 11, active: true}
        ]
    };
    recs: any[] = [];
    categories: any[] = [];

    constructor(private spinner: SpinnerService,
        private recurrentService: RecurrentService,
        private categoryService: CategoryService) { }

    ngOnInit() {
        this.getRecurrents();
        this.getCategories();
    }

    getRecurrents() {
        this.spinner.startLoad('recurrent-list-getRecurrents');
        this.recurrentService.getRecurrents().subscribe(
            (res) => this.recs = res,
            (err) => console.error(err),
            () => this.spinner.finishLoad('recurrent-list-getRecurrents')
        );
    }

    getCategories() {
        this.spinner.startLoad('recurrent-list-getCategories');
        this.categoryService.getCategories().subscribe(
            (res) => this.categories = res,
            (err) => console.error(err),
            () => this.spinner.finishLoad('recurrent-list-getCategories')
        );
    }

    createRecurrent() {
        this.spinner.startLoad('recurrent-list-createRecurrent');
        this.newRec.amount = this.newRec.amount * this.amount_multiplier;
        this.recurrentService.createRecurrent(this.newRec).subscribe(
            (res) => this.getRecurrents(),
            (err) => console.error(err),
            () => this.spinner.finishLoad('recurrent-list-createRecurrent')
        );
    }

    monthToDate(month: number): Date {
        return new Date(new Date().setMonth(month));
    }

    setAllMonths(val: boolean) {
        this.newRec.months =this.newRec.months.map(function(month) {
            month.active = val;
            return month;
        });
    }
}
